import { render, staticRenderFns } from "./Custom3.vue?vue&type=template&id=345cfe00&"
import script from "./Custom3.vue?vue&type=script&lang=js&"
export * from "./Custom3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports